"use strict";
/**
 * @module Services
 */
Object.defineProperty(exports, "__esModule", { value: true });
var require_non_null_1 = require("./../util/require-non-null");
/**
 * Result that either succeed or fail with parser errors.
 */
var ErrorReportList = /** @class */ (function () {
    /**
     * Create a new ErrorReportList
     *
     * @param errors a list of error reports; empty if successful
     */
    function ErrorReportList(errors) {
        this.errors = require_non_null_1.requireNonNull(errors, 'errors');
    }
    /**
     * Convert object to string
     *
     * @return a string representation of the object
     */
    ErrorReportList.prototype.toString = function () {
        return 'ErrorReportList [' + this.errors + ']';
    };
    return ErrorReportList;
}());
exports.ErrorReportList = ErrorReportList;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/error-report-list.js
// module id = 1310
// module chunks = 1